module.exports = __webpack_public_path__ + "img/1523915367.162717bd.jpg";